"use client";

import { RouteErrorBoundary } from "@/components/states/route-error";

/**
 * Error boundary for the docs tree. Keeps the docs layout (nav) while
 * recovering the article body.
 */
export default function DocsError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorBoundary {...props} source="boundary:docs" />;
}
